import { ActivityTemplate } from '../../models';
import { useCallback, useEffect, useState } from 'react';

type FormData = {
  roomName: string;
  activateTime: string;
  activityTemplate: ActivityTemplate;
};

export function useCreateChatroomDataGroup(): [
  {
    isValid: boolean;
    data: FormData;
  },
  (key: string, value: any) => void
] {
  const [isValid, setIsValid] = useState(false);
  const [formData, setFormData] = useState<FormData>({} as FormData);

  const updateFormValue = useCallback((key: string, value: any) => {
    setFormData((preValue) => {
      return {
        ...preValue,
        [key]: value,
      };
    });
  }, []);

  useEffect(() => {
    setIsValid(
      () =>
        !!formData.activityTemplate &&
        !!formData.roomName &&
        !!formData.activateTime
    );
  }, [formData]);

  return [
    {
      isValid,
      data: formData,
    },
    updateFormValue,
  ];
}
